var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.980713 5.62492H11.5356L8.30376 1.80992C7.98885 1.43892 8.04045 0.886795 8.41763 0.57792C8.7957 0.26817 9.35614 0.31892 9.67016 0.68992L14.1181 5.93992C14.1528 5.98105 14.1706 6.02917 14.1964 6.07467C14.2177 6.11142 14.2435 6.14292 14.2595 6.18317C14.2996 6.28379 14.3236 6.38967 14.3236 6.49642C14.3236 6.4973 14.3245 6.49904 14.3245 6.49992C14.3245 6.50079 14.3236 6.50254 14.3236 6.50342C14.3236 6.61017 14.2996 6.71604 14.2595 6.81667C14.2435 6.85692 14.2177 6.88842 14.1964 6.92517C14.1706 6.97067 14.1528 7.0188 14.1181 7.05992L9.67016 12.3099C9.49403 12.5173 9.24138 12.6249 8.98696 12.6249C8.78592 12.6249 8.58398 12.5584 8.41763 12.4219C8.04045 12.113 7.98885 11.5609 8.30376 11.1899L11.5356 7.37492H0.980713C0.489663 7.37492 0.0911293 6.98292 0.0911293 6.49992C0.0911293 6.01692 0.489663 5.62492 0.980713 5.62492Z",
    fill: "#505050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.7964b2605ab3e385e4e74f77a22fba66.svg";
export { ForwardRef as ReactComponent };